// Import Dependencies
import React from 'react';
import PropTypes from 'prop-types';

// Import Utils
import { getClassNames } from '../../../utils';

const Button = ({
  children,
  secondary,
  white,
  blue,
  calendar,
  icon,
  close,
  fullHeight,
  borderZero,
  fixedWidth,
  monthSlider,
  noBackground,
  isActive,
  addToPack,
  cyopInverse,
  cyopModal,
  cyopModalWithLoader,
  cyopModalNext,
  clickable,
  disabled,
  ...props
}) => (
  <button
    type="button"
    className={getClassNames(props, 'c-button', {
      'c-button--secondary': secondary,
      'c-button--white': white,
      'c-button--blue': blue,
      'c-button--icon': icon,
      'c-button--calendar': calendar,
      'c-button--clickable': clickable,
      'c-button--icon-close': close,
      'c-button--full-height': fullHeight,
      'c-button--border-zero': borderZero,
      'c-button--width-fixed': fixedWidth,
      'c-button--add-to-pack': addToPack,
      'c-button--cyop-inverse': cyopInverse,
      'c-button--cyop-modal': cyopModal,
      'c-button--cyop-modal-with-loader': cyopModalWithLoader,
      'c-button--cyop-modal-next': cyopModalNext,
      'c-button--no-background': noBackground,
      'c-button--disabled': disabled,
      'js-month-button': monthSlider,
      'is-active': isActive,
    })}
    {...props}
  >
    {children}
  </button>
);

Button.propTypes = {
  children: PropTypes.node.isRequired,
  calendar: PropTypes.bool,
  icon: PropTypes.bool,
  close: PropTypes.bool,
  secondary: PropTypes.bool,
  white: PropTypes.bool,
  blue: PropTypes.bool,
  fullHeight: PropTypes.bool,
  fixedWidth: PropTypes.bool,
  borderZero: PropTypes.bool,
  monthSlider: PropTypes.bool,
  noBackground: PropTypes.bool,
  isActive: PropTypes.bool,
  addToPack: PropTypes.bool,
  cyopInverse: PropTypes.bool,
  cyopModal: PropTypes.bool,
  cyopModalWithLoader: PropTypes.bool,
  cyopModalNext: PropTypes.bool,
  clickable: PropTypes.bool,
  disabled: PropTypes.bool,
};

Button.defaultProps = {
  calendar: false,
  icon: false,
  close: false,
  secondary: false,
  white: false,
  blue: false,
  fullHeight: false,
  fixedWidth: false,
  borderZero: false,
  monthSlider: false,
  noBackground: false,
  isActive: false,
  addToPack: false,
  cyopInverse: false,
  cyopModal: false,
  cyopModalWithLoader: false,
  cyopModalNext: false,
  clickable: false,
  disabled: false,
};

export default Button;
